import { QueryAggregator } from "@/api/utils/QueryAggregator"
import { AccountService } from "@/services/AccountService"
import { NoteService } from "@/services/NotesService"

export const getNotes = (accountNumber: string) => {
  const queries = new QueryAggregator()

  const coreIdQuery = AccountService.getCoreIdByAccountNumber(accountNumber)
  const notesQuery = NoteService.getForAccount(coreIdQuery.data)

  queries.add(coreIdQuery)
  queries.add(notesQuery)

  return queries.setData(notesQuery.data).getAggregate()
}
